import React from 'react'
import photo from '../../../images/sorenbn_photo.jpg'
import './SectionProfile.css'


const SectionProfile = () => {
    return (
        <div className="row py-4">
            <div className="col-xs-12 col-sm-4 text-center">
                <img className="px-4 pb-4 p-sm-0 profile-pic" src={photo} alt="" />
            </div>
            <div className="col-xs-12 col-sm-8">
                <h1 className="fw-bold m-0">SØREN BACH NIELSEN</h1>
                <h4 className="mb-3">Software & Game Developer</h4>
                <p>Hi! My name is Søren and I'm a software and game developer living in Copenhagen, Denmark. </p>
                <p>I've always had a thing for computers and technology and I started out early playing around
                    with GameMaker Studio and Unity3D in it's early days.
                    Since then, I've graduated from EADania in Computer Science and worked on
                    several mobile games professionally afterwards. </p>
                <p>I'm currently working as a Senior Software Developer at twoday Minds</p>
            </div>
        </div>
    )
}

export default SectionProfile
